<template>
    <!--
        Lesson component.
        Displays content inside a layer above the page content.
        Closable by clicking button OKAY, background-layer or pressing esc-key
    -->
    <div class="modal modal--lesson">
        <transition name="fade">
            <div class="modal-background" @click.stop="close" v-if="show"></div>
        </transition>

        <transition name="slide-right">
            <div class="modal-content" v-if="show">
                <div class="head" v-if="headline !== ''">
                    <h2 v-html="headline"></h2>
                    <icon name="check" class="status" v-if="viewed" />
                </div>

                <div v-if="content" class="body">
                    <div v-html="content"></div>
                    <div class="links" v-if="links.length">
                        <h4>{{ $t('university.lesson.related') }}</h4>
                        <ul>
                            <li v-for="link in links"><a href="#" @click.prevent="learn(link)">{{ link.name }}</a></li>
                        </ul>
                    </div>
                </div>

                <div class="modal-footer">
                    <action @click.native="performAction" color="orange" style="float:left" v-if="action">{{ $t('university.lesson.try') }}</action>
                    <action @click.native="close" color="blue" style="float:left">{{ $t('common.button.done') }}</action>
                    <action @click.native="previousStep" color="transparent" v-if="previous && next">{{ $t('common.button.back') }}</action>
                    <action @click.native="nextStep" color="green" v-if="next">{{ $t('label.moment.next') }}</action>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import events from '../../events/events';

window.removeEventListener('keyup', this.keyListener, false);

export default
{
    name: 'Lesson',

    data() {
        return {
            show: false,
            id: null,
            headline: '',
            content: '',
            links: [],
            callback: null,
            viewed: false,
            action: false,
            lessons: [],
        }
    },

    created()
    {
        /**
         * Open lesson.
         * Adds event listener to window object for key esc
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        events.$listen('lesson.open', (lesson, callback) =>
        {
            this.id = lesson.id;
            this.headline = lesson.name || '';
            this.content = lesson.content;
            this.links = lesson.links || [];
            this.viewed = lesson.viewed;
            this.action = lesson.action;
            this.callback = callback;

            this.lessons = this.$university.lessons;

            this.show = true;

            this.$http.put('/api/lessons/' + lesson.id + '/view', {
                membership: this.$store.state.current.membership.id
            });

            if (lesson.page)
            {
                this.$router.push(this.$onduro.route(lesson.page));
            }

            if (lesson.id == 'XmWkjRkeGL')
            {
                // disable onboarding
                this.$http.put('/api/memberships/' + this.$store.state.current.membership.id + '/onboarding')
                .then(response => 
                {
                    this.$store.dispatch('current/updateMembership', {
                        onboarding: 0
                    });
                });
            }

            window.addEventListener('keyup', this.keyListener, false);
        });

        events.$listen('university.expand', () =>
        {
            this.show = true;
        });
    },

    computed:
    {
        previous()
        {
            let key = _.findKey(this.lessons, {id: this.id});

            if (key > 0) return this.lessons[key - 1];

            return false;
        },

        next()
        {
            let key = _.findKey(this.lessons, {id: this.id});
            let next = parseInt(key) + 1;

            if (next < this.lessons.length) return this.lessons[next];

            return false;
        },
    },

    methods:
    {
        confirm()
        {
            this.close();
        },

        learn(link)
        {
            let lesson = _.find(this.$university.lessons, {id: link.id});

            if ( ! lesson) {
                this.$modal.show('Cannot find lesson');
            } else {
                this.$university.lesson(lesson);
            }
        },

        previousStep()
        {
            this.markViewed();
            this.$university.lesson(this.previous);
        },

        nextStep()
        {
            this.markViewed();
            this.$university.lesson(this.next);
        },

        back()
        {
            this.markViewed();

            // remove current item
            this.$university.history.splice(-1, 1);

            let id = this.$university.history[this.$university.history.length - 1];
            let lesson = _.find(this.$university.lessons, {id: id});

            // remove previous item (since it will be added back right away)
            this.$university.history.splice(-1, 1);

            this.$university.lesson(lesson);
        },

        performAction()
        {
            this.show = false;

            events.$emit('university.minify');
        },

        /**
         * Close dialog and remove event listener from window
         */
        close()
        {
            this.markViewed();

            this.$university.history = [];

            window.removeEventListener('keyup', this.keyListener, false);

            this.show = false;

            if (typeof this.callback == 'function') this.callback();

            this.headline = '';
            this.content = '';
            this.links = [];
            this.callback = null;
        },

        keyListener(e) 
        {
            switch (e.keyCode)
            {
                case 27:
                this.close();
                break;

                case 37:
                if (this.previous) this.previousStep();
                break;

                case 39:
                if (this.next) this.nextStep();
                break;
            }
        },

        markViewed()
        {
            let key = _.findKey(this.lessons, {id: this.id});
            
            if (key)
            {
                this.$set(this.lessons[key], 'viewed', true);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// Lesson.vue?1ea45763